import React from 'react';

import styles from './Footer.module.scss';

export const Footer = () => {
	return (
		<div className={styles.footer}>
			<span className={styles.footerText}>
				© Copyright {new Date().getFullYear()}{' '}
				<span className={styles.companyName}>Tata Motors</span>. All rights
				reserved
			</span>
		</div>
	);
};
